module.exports = __webpack_public_path__ + "img/xxdt.f4653dc1.png";